import i18n from "i18next"
import {initReactI18next} from "react-i18next"
import Backend from "i18next-http-backend"
import LanguageDetector from "i18next-browser-languagedetector"

import translationDE from "./messages/de.json"
import translationFR from "./messages/fr.json"
import translationIT from "./messages/it.json"

const resources = {
  de: {
    translation: translationDE
  },
  fr: {
    translation: translationFR
  },
  it: {
    translation: translationIT
  }
}

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  // .use(Backend)
  .init({
    debug: true,
    fallbackLng: "de",
    interpolation: {
      escapeValue: false // not needed for react as it escapes by default
    },
    resources
  })

export default i18n



// WEBPACK FOOTER //
// ./src/i18n.js